export const USER_PRIVACY_STATUS_PRIVATE = 'PRIVATE';
export const USER_PRIVACY_STATUS_PUBLIC = 'PUBLIC';
